let startInfo;
export function setStartInfo(newStartInfo) {
    startInfo = newStartInfo;
}
export function getStartInfo() {
    return startInfo;
}
